// extracted by mini-css-extract-plugin
export default {"titleName":"TitleLogo_titleName__mni-H","logo":"TitleLogo_logo__GKakL","containerTitleLogo":"TitleLogo_containerTitleLogo__9z8Do"};